function toBase64Url(value) {
  const bytes = new TextEncoder().encode(value);
  let binary = '';
  bytes.forEach((byte) => { binary += String.fromCharCode(byte); });
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function fromBase64Url(value) {
  const base64 = String(value || '').replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64 + '='.repeat((4 - (base64.length % 4 || 4)) % 4);
  const binary = atob(padded);
  const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
  return new TextDecoder().decode(bytes);
}

export function encodeJourneyPreviewPayload(payload) {
  if (!payload || typeof payload !== 'object') return '';
  return toBase64Url(JSON.stringify({ v: 1, overlay: payload }));
}

export function decodeJourneyPreviewPayload(value) {
  if (!value) return null;
  try {
    const parsed = JSON.parse(fromBase64Url(value));
    if (parsed?.v !== 1 || !parsed.overlay || typeof parsed.overlay !== 'object') return null;
    return parsed.overlay;
  } catch {
    return null;
  }
}
